import React from "react";
import { useTranslation } from "react-i18next";
import ContentContainer from "../components/ContentContainer";
import PageHeader from "../components/PageHeader";
import "./When.css";

function When() {
  const { t } = useTranslation();

  return (
    <div className="when-page">
      <ContentContainer>
        <PageHeader 
          title={t("when.title")}
          subtitle={t("when.subtitle")}
        />

        {/* Past Editions Section */}
        <section className="when-section">
          <h2 className="when-section-title">{t("when.pastEditionsTitle")}</h2>
          <p className="when-section-intro">{t("when.pastEditionsIntro")}</p>
          
          <div className="editions-list">
            <div className="edition-card">
              <div className="edition-header">
                <h3 className="edition-name">{t("when.past1Name")}</h3>
                <span className="edition-year">{t("when.past1Year")}</span>
              </div>
              <div className="edition-details">
                <p className="edition-location">
                  <strong>{t("when.location")}:</strong> {t("when.past1Location")}
                </p>
                <p className="edition-event">
                  <strong>{t("when.event")}:</strong> {t("when.past1Event")}
                </p>
                <p className="edition-description">{t("when.past1Description")}</p>
              </div>
            </div>
            <div className="edition-card">
              <div className="edition-header">
                <h3 className="edition-name">{t("when.past2Name")}</h3>
                <span className="edition-year">{t("when.past2Year")}</span>
              </div>
              <div className="edition-details">
                <p className="edition-location">
                  <strong>{t("when.location")}:</strong> {t("when.past2Location")}
                </p>
                <p className="edition-event">
                  <strong>{t("when.event")}:</strong> {t("when.past2Event")}
                </p>
                <p className="edition-description">{t("when.past2Description")}</p>
              </div>
            </div>
            <div className="edition-card">
              <div className="edition-header">
                <h3 className="edition-name">{t("when.past3Name")}</h3>
                <span className="edition-year">{t("when.past3Year")}</span>
              </div>
              <div className="edition-details">
                <p className="edition-location">
                  <strong>{t("when.location")}:</strong> {t("when.past3Location")}
                </p>
                <p className="edition-event">
                  <strong>{t("when.event")}:</strong> {t("when.past3Event")}
                </p>
                <p className="edition-description">{t("when.past3Description")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Donations Report Section */}
        <section className="when-section">
          <h2 className="when-section-title">{t("when.donationsReportTitle")}</h2>
          <p className="when-section-intro">{t("when.donationsReportIntro")}</p>
          
          <div className="donations-report">
            <div className="donation-item">
              <h3 className="donation-item-title">{t("when.donationSatochipJavaCardsTitle")}</h3>
              <p className="donation-item-description">{t("when.donationSatochipJavaCardsDescription")}</p>
            </div>
            <div className="donation-item">
              <h3 className="donation-item-title">{t("when.donationSatochipKitsTitle")}</h3>
              <p className="donation-item-description">{t("when.donationSatochipKitsDescription")}</p>
            </div>
            <div className="donation-item">
              <div className="donation-item-header">
                <img 
                  src={`${process.env.PUBLIC_URL}/assets/images/Logo_Light_White_512x512.png`}
                  alt="Seedor.io logo"
                  className="donation-logo"
                />
                <h3 className="donation-item-title">{t("when.donationSeedorTitle")}</h3>
              </div>
              <p className="donation-item-description">{t("when.donationSeedorDescription")}</p>
              <div className="donation-item-link">
                <a 
                  href="https://www.seedor.io/en-int"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="donation-link"
                >
                  {t("when.visitWebsite")} → Seedor.io
                </a>
              </div>
            </div>
          </div>
        </section>
      </ContentContainer>
    </div>
  );
}

export default When;

